import type { Evaluation } from "@offsite/shared";

/**
 * Shared evaluation detail panel — used in both EvaluatingOverlay (when a
 * team has finished) and EvaluatedOverlay. Dark theme, inherits from
 * `.eval-board` parent.
 */
export function EvalDetail({ evaluation }: { evaluation: Evaluation }) {
  const score = evaluation.score;
  const tone = score >= 7 ? "is-good" : score >= 4 ? "" : "is-warn";
  const pct = Math.max(0, Math.min(100, (score / 10) * 100));

  return (
    <div className="eval-board-detail">
      <div className="eval-board-detail-head">
        <div className="eyebrow">
          Team {evaluation.teamNumber}
          {evaluation.teamName ? ` · ${evaluation.teamName}` : ""}
        </div>
      </div>

      <div className="eval-board-score">
        <div className="num">
          {score.toFixed(1)}
          <span className="max"> / 10</span>
        </div>
        <div className="score-bar-track">
          <div className={`score-bar-fill ${tone}`} style={{ width: `${pct}%` }} />
        </div>
      </div>

      <blockquote className="eval-board-quote">
        „{evaluation.zusammenfassung}"
      </blockquote>

      <div className="eval-board-cards">
        <div className="eval-board-card is-strengths">
          <h4>✓ Was ist gut</h4>
          <ul>
            {evaluation.gut.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </div>
        <div className="eval-board-card is-improvements">
          <h4>△ Was ist ausbaufähig</h4>
          <ul>
            {evaluation.ausbaufaehig.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </div>
      </div>

      <footer className="eval-board-footer">
        Modell: <code>{evaluation.modelId}</code> ·{" "}
        {(evaluation.durationMs / 1000).toFixed(1)}s ·{" "}
        {evaluation.inputTokens}/{evaluation.outputTokens} Tokens
      </footer>
    </div>
  );
}
